





import { Component, Prop, Vue } from 'vue-property-decorator';
import echarts from 'echarts';
@Component({})
export default class EchartsColumn extends Vue {
  @Prop({ default: [] })
  private xData: any;
  @Prop({ default: [] })
  private yData: any;
  @Prop({ default: 1})
  private allNum: any;
  // @Prop({ default: [] })
  // private tableJson: any;
  private option: any = {
    color: ['#1890ff'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {            // 坐标轴指示器，坐标轴触发有效
          type: 'shadow',     // 默认为直线，可选为：'line' | 'shadow'
      },
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: ('category' as 'category'),
      axisLine: {
        lineStyle: {
          // type: ('dashed' as 'dashed'),
        },
      },
      data: this.xData,
      axisTick: {
        alignWithLabel: true,
      },
    },
    yAxis: [
      {
        type: 'value',
      },
    ],
    series: [
      {
        name: '个数',
        type: 'bar',
        barWidth: '50%',
        data: this.yData,
      },
    ],
    formatter: (params: any) => {
      let res  =  '';
      res += '<style>td{padding:5px;}</style><table>';
      res += '<tr><td>City:</td><td>' + params[0].name + '</td>';
      res += '<tr><td>Number:</td><td>' + params[0].value + '</td>';
      res += '<tr><td>Permillage:</td><td>' + this.returnPercentage(params[0].value) +  '‰</td>';
      res += '</table>';
      return res;
    },
  };
  private mounted() {
    this.createEcharts();
  }
  private returnPercentage(value: number) {
    const num = (Number((value / this.allNum).toFixed(4)) * 1000).toFixed(2);
    return num;
  }
  private createEcharts() {
    const ele = document.getElementById('myEcharts');
    const chart: any = echarts.init(ele as HTMLCanvasElement);
    // 调接口获取数据
    chart.setOption(this.option);
  }

}
